











import Vue from 'vue'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import AssetManager from '@/components/AssetManager'
import './AssetManagement.scss'
import { AbilitySubject, AbilityAction } from '@/abilitiesByRole'

export default Vue.extend({
  name: 'AssetManagement',
  computed: {
    canReadAssets () {
      return this.$can(AbilityAction.Read, AbilitySubject.AssetGroups)
    },
    teamCheck () {
      return this.$store.direct.state.user.teamCheck
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    userId (): string {
      return this.$store.direct.state.user.id
    }
  },
  components: {
    LeftSidebarLayout,
    AssetManager
  }
})
